import React, { useEffect, useState, useRef } from 'react'
import { message, } from 'antd'
import request from 'meinian-package/src/utils/request'
import GalleryModal from './galleryModal'
import './index.less'

const MAX_SELECT_COUNT = 20
let uploadCount = 0

export default ({ images, onChange, children }) => {
  const [visible, setVisible] = useState(false)
  const [tempValue, setTempValue] = useState([])
  const [params] = useState({ pageSize: 100, pageNo: 1 })
  const [materials, setMaterials] = useState([])
  const [currentIdeaMassId, setcurrentIdeaMassId] = useState(undefined)
  const [recentIdeaMasses, setRecentIdeaMasses] = useState([])
  const [insList, setInsList] = useState([])
  const [keyWords, setKeyWords] = useState('')
  const [count, setCount] = useState(0)
  const [doneCount, setDoneCount] = useState(0)
  const [isEmpty, setIsEmpty] = useState(false)
  const [start, setStart] = useState(0)
  const [isEnd, setIsEnd] = useState(false)
  const [loading, setLoading] = useState(false)
  const $list = useRef()

  useEffect(() => {
    fetchRecentIdeaMasses()
  }, [])

  useEffect(() => {
    setStart(0)
    fetchInsList(0)
  }, [keyWords])

  const fetchRecentIdeaMasses = async () => {
    const res = await request.get('ins/inspiration/recently-used?limit=5&type=1')
    setRecentIdeaMasses(res)
  }
  const fetchMaterials = async (_count) => {
    const res = await request.get('/zhikuan/materials/materials-list', { params })
    setMaterials({ ...res, resultList: res.resultList?.map(m => ({ ...m, mainUrl: m.materialUrl })) })
    if (_count) {
      for (let i = 0; i < _count; i++) {
        events.onAddToTemp({ ...res.resultList[i], mainUrl: res.resultList[i].materialUrl })
      }
    }
  }
  const fetchInsList = async (_start) => {
    try {
      setLoading(true)
      const res = await request.spost(`/zhikuan/ins/inspiration/list-inspiration?start=${_start}&pageSize=20`, {
        start: _start,
        pageSize: 20,
        rankStatus: -2,
        queryType: 3,
        topFirstStatus: 1,
        keyWords,
      })
      _start === 0 ? setInsList(res.resultList) : setInsList(pre => ([...pre, ...res.resultList]))
      setStart(pre => pre + 20)
      setIsEnd(!res.resultList?.length)
      setIsEmpty(false)
      if (keyWords && _start === 0) {
        if (res.resultList.length) {
          setcurrentIdeaMassId(res.resultList[0].id)
        } else {
          setIsEmpty(true)
        }
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.error(err)
    }
  }
  const onClickAdd = () => {
    fetchMaterials()
    fetchRecentIdeaMasses()
    if (images) {
      setTempValue([...images])
    }
    setcurrentIdeaMassId(undefined)
    setKeyWords(undefined)
    setIsEmpty(false)
    setVisible(true)
  }

  const events = {
    onClickDel(image, e) {
      e.stopPropagation()
      if (images.length < 2) {
        return message.warn('至少保留一张图片')
      }
      onChange(images.filter(m => m.mainUrl !== image.mainUrl))
    },
    onChangeMainImg(_images, image, e) {
      e.stopPropagation()
      const newImages = _images.filter(m => m.mainUrl !== image.mainUrl)
      newImages.unshift(image)
      onChange(newImages)
    },
    onUploadProgress(fileList) {
      setCount(fileList.length)
      setDoneCount(0)
      uploadCount = 0
    },
    async onUpload(url, fileName, files) {
      const model = { ...materials?.param, materialUrl: url, fileName }
      try {
        await request.post('/zhikuan/materials/add-materials', model)
        if (uploadCount + 1 === files.length) {
          await fetchMaterials(files.length)
        }
        setDoneCount(++uploadCount)
      } catch (error) {
        console.error(error)
      }
    },
    onAddToTemp(image) {
      if (tempValue.length >= MAX_SELECT_COUNT) {
        return
      }
      tempValue.push(image)
      setTempValue([...tempValue])
    },
    onDelTempValue(image, e) {
      e && e.stopPropagation()
      setTempValue(tempValue.filter(m => m.mainUrl !== image.mainUrl))
    },
    onClickImg(image) {
      if (tempValue.some(m => m.mainUrl === image.mainUrl)) {
        events.onDelTempValue(image)
        return
      }
      events.onAddToTemp(image)
    },
  }
  const onLoad = () => {
    if (isEnd) return
    fetchInsList(start)
  }
  const onChangeKey = (_keyWords) => {
    setKeyWords(_keyWords)
  }

  return <div className="meinian-image-gallery">
    {visible ? <GalleryModal
      visible={visible}
      setVisible={setVisible}
      setTempValue={setTempValue}
      images={images}
      onChange={onChange}
      tempValue={tempValue}
      $list={$list}
      onChangeKey={onChangeKey}
      keyWords={keyWords}
      setcurrentIdeaMassId={setcurrentIdeaMassId}
      currentIdeaMassId={currentIdeaMassId}
      recentIdeaMasses={recentIdeaMasses}
      insList={insList}
      onLoad={onLoad}
      isEnd={isEnd}
      loading={loading}
      isEmpty={isEmpty}
      events={events}
      count={count}
      doneCount={doneCount}
      materials={materials}
      setMaterials={setMaterials}
    /> : null}
    <div onClick={() => onClickAdd()}>
      {children}
    </div>
  </div>
}
